<script setup>
const route = useRoute()
const { getPostForRoute } = useApiPost()

// Meta
const { generateMeta, generateBreadcrumbs } = useMetaUtils()
const { formatDate } = useFormatters()

const { data: post } = await useAsyncData(
  `post-${route.params.slug}`,
  getPostForRoute,
)

const metaData = computed(() => generateMeta(post.value))

useHead(metaData)
</script>

<template>
  <article>
    <SectionsHero
      :breadcrumbs="
        generateBreadcrumbs({
          slug: post?.slug,
          title: post?.title,
          parent: {
            title: 'Blog',
            slug: 'blog',
          },
        })
      "
      :content="{
        title: post?.title,
        content: formatDate(post?.createdAt),
        style: 'Primary',
      }"
      first-is-hero
    />
    <BaseContainer size="sm" class="-mb-5 mt-5 lg:-mb-10 lg:mt-10">
      <div class="mb-5 flex lg:mb-10">
        <NuxtLink
          to="/blog"
          class="flex items-center gap-x-3 font-mono text-sm text-secondary"
        >
          <i
            class="flex h-5 w-5 items-center justify-center rounded-full bg-secondary"
          >
            <IconChevronLeft class="h-2 w-2 text-white" />
          </i>
          <span>Terug naar overzicht</span>
        </NuxtLink>
      </div>
      <div
        v-if="post?.image"
        class="overflow-hidden rounded-2xl lg:rounded-3xl"
      >
        <BaseVisual
          :file="post?.image"
          fetchpriority="low"
          size="medium"
          :lazy="true"
          class="md:hidden"
        />
        <BaseVisual
          :file="post?.image"
          fetchpriority="low"
          :lazy="true"
          class="hidden md:block"
          width="100%"
        />
      </div>
    </BaseContainer>
    <BaseContent v-if="post?.content" :content="post?.content" />
  </article>
</template>
